import React from "react";

const Sample = (value) => {
  const RGB = function (R, G, B) {
    if (R === 0) {
      return {
        background: "RGB(" + (150 - G * 10) + ", 250, 0)",
      };
    } else if (R < 5) {
      return {
        background:
          "RGB(" +
          (200 - G * 10 + R * 70) +
          ", " +
          (250 - R * 10 + G * 10) +
          ", 0)",
      };
    } else {
      var Row = Number(
        Object.keys(value.data.sample_size_matrix).length / 2
      ).toFixed(0);
      var Col = Number(
        Object.keys(value.data.confidence_level_matrix).length / 2
      ).toFixed(0);

      var sampleSizeErrorLevel = Number(
        value.data?.sample_size_error_level * 100
      ).toFixed(1);
      var confidence_level = Number(
        value.data?.arguments.confidence_level * 100
      ).toFixed(1);

      if (
        Number(value.data.sample_size_error_level_matrix[R] * 100).toFixed(
          1
        ) === sampleSizeErrorLevel &&
        Number(value.data.confidence_level_matrix[G] * 100).toFixed(1) ===
        confidence_level
      ) {
        return {
          background:
            "RGB(" +
            (250 - G * 10 + R * 70) +
            ", " +
            (250 - R * 25 + G * 15) +
            ", 0)",
          fontWeight: 700,
          fontSize: "15px",
        };
      } else {
        return {
          background:
            "RGB(" +
            (250 - G * 10 + R * 70) +
            ", " +
            (250 - R * 25 + G * 15) +
            ", 0)",
        };
      }
    }
  };

  return (
    <div>
      <div className="container">
        <div>
          <div>
            <div className="details-container">
              <strong style={{ fontSize: "16px" }}>
                {" "}
                LogRatio - Sample Size: Sensitivity analysis
              </strong>
              <div className="mt-2">
                {" "}
                <label> @LogRatio report ID: </label>{" "}
                <div>{value.data?.arguments.log_id} </div>
              </div>
              <div>
                {" "}
                <label> - Population size: </label>{" "}
                <div>{value.data?.arguments.population_size} </div>
              </div>
              <div>
                {" "}
                <label> - Confidence level: </label>{" "}
                <div>
                  {Number(value.data?.arguments.confidence_level * 100).toFixed(
                    1
                  )}
                  %{" "}
                </div>
              </div>
              <div className="special">
                {" "}
                <label> - Error level: </label>{" "}
                <div>
                  {Number(value.data?.sample_size_error_level * 100).toFixed(1)}
                  %
                </div>
              </div>
              <div>
                {" "}
                <label> - Population proportion: </label>{" "}
                <div>{value.data?.arguments.study_hypothesis}</div>
              </div>
              <div>
                {" "}
                <label> - Sample size: </label>{" "}
                <div>{value.data?.real_sample_size}</div>
              </div>
            </div>
            <div>
              <div className="d-flex justify-content-end">
                <a
                  className="help-link"
                  href="#!"
                  onClick={() => window.parent.postMessage({
                    cmd: "hyperlink",
                    url: "https://logratio.com/users-guide/#sample-size-analysis"
                  }, "https://logratio.com")}
                >
                  Help with this analysis
                </a>
              </div>
            </div>
          </div>

          <div>
            <table className="sample-table">
              <thead>
                <tr>
                  <th></th>
                  <th
                    colSpan={
                      Object.keys(value.data.sample_size_error_level_matrix)
                        .length
                    }
                    style={{ fontSize: "16px" }}
                  >
                    Error level
                  </th>
                </tr>
                <tr>
                  <th style={{ width: "95px" }}>Confidence level</th>
                  {value.data.sample_size_error_level_matrix.map(
                    (item, index) => (
                      <th key={index}>{Number(item * 100).toFixed(1)}%</th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {value.data.confidence_level_matrix.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <strong>{Number(item * 100).toFixed(1)}</strong>
                    </td>
                    {value.data.sample_size_matrix.map(
                      (error_item, error_index) => (
                        <td
                          key={error_index}
                          style={RGB(error_index, index, 0)}
                        >
                          {error_item[index]}
                        </td>
                      )
                    )}
                  </tr>
                ))}
              </tbody>
              <tfoot></tfoot>
            </table>
          </div>

          <div className="mt-4">
            <table
              className="sample-table"
              style={{ width: "230px", marginTop: "30px" }}
            >
              <thead>
                <tr>
                  <th style={{ borderBottom: "solid 2px", width: "50px" }}>
                    Risk level
                  </th>
                  <th style={{ borderBottom: "solid 2px" }}>
                    Decisional strength
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ background: "#63be7b" }}>1</td>
                  <td>Very low risk</td>
                </tr>
                <tr>
                  <td style={{ background: "#a6d17e" }}>2</td>
                  <td>Low risk</td>
                </tr>
                <tr>
                  <td style={{ background: "#eae582" }}>3</td>
                  <td>Somewhat risky</td>
                </tr>
                <tr>
                  <td style={{ background: "#fdc07c" }}>4</td>
                  <td>Risky</td>
                </tr>
                <tr>
                  <td style={{ background: "#fb9a75" }}>5</td>
                  <td>Very high risk</td>
                </tr>
                <tr>
                  <td
                    style={{ background: "#f8696b", borderBottom: "solid 2px" }}
                  >
                    6
                  </td>
                  <td style={{ borderBottom: "solid 2px" }}>Use as pilot only</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sample;
